import React, { Component } from "react";
import HyperLink from "./HyperLink";

export default class EmailLink extends Component<{ email: string; style?; children?: React.ReactNode }> {
	state = {
		emailLink: "",
		emailDisplay: "",
	};

	componentDidMount() {
		const { email } = this.props;
		let emailLink, emailDisplay;
		if (email.indexOf("mailto:") > -1) {
			emailLink = email;
			emailDisplay = email.substring(email.indexOf("mailto:") + 7);
		} else {
			emailLink = `mailto:${email}`;
			emailDisplay = this.props.email;
		}
		this.setState({ emailLink, emailDisplay });
	}

	render() {
		if (!this.props.email) return null;
		return (
			<HyperLink
				url={this.state.emailLink}
				title={this.state.emailDisplay}
				ignoreLinkCheck={true}
				style={this.props.style}
				children={this.props.children}
			/>
		);
	}
}
